export const stats = [
  {
    title: "1.5M",
    content: "which is approximately 56% of the consumer population of the US",
  },
  {
    title: "41%",
    content: "The largest adopters due to being comfortable with technology",
  },
  {
    title: "3964+",
    content:
      "The online payment system offers electronic alternatives to traditional",
  },
];
